// Mock data for LUKOIL EKTO website

export const stations = [
  {
    id: 1,
    name: "LUKOIL EKTO - Şah İsmayıl Xətai",
    address: "Gəncə, Şah İsmayıl Xətai ev. 203 B",
    phone: "+994 55 988 30 30",
    workingHours: "24 saat açıqdır",
    services: ["Ofis", "Market", "Restoran"],
    hasCarWash: false,
    images: [
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/x5s5kb77_IMG_2396.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/b03r8vuj_IMG_2397.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/gaxykgsv_IMG_2398.jpeg"
    ]
  },
  {
    id: 2,
    name: "LUKOIL EKTO - Museyib Bağırov",
    address: "Gəncə, Museyib Bağırov küç. 173",
    phone: "+994 55 988 30 30",
    workingHours: "24 saat açıqdır",
    services: ["Market"],
    hasCarWash: false,
    images: [
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/dhl18xxz_IMG_2393.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/yqw4ja9s_IMG_2394.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/cl21hsf3_IMG_2395.jpeg"
    ]
  },
  {
    id: 3,
    name: "LUKOIL EKTO - Gəncə-Bakı şosesi",
    address: "Gəncə, Gəncə–Bakı şosesi, 1-ci km",
    phone: "+994 55 988 30 30",
    workingHours: "24 saat açıqdır",
    services: ["Market", "Motel", "Kafe", "Namaz otağı", "Avtoyuma"],
    hasCarWash: true,
    images: [
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/t4ikznhr_IMG_2413.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/vlnvzmy6_IMG_2414.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/3xeu4x7a_IMG_2415.jpeg"
    ]
  },
  {
    id: 4,
    name: "LUKOIL EKTO - Gəncə-Daşkəsən şosesi",
    address: "Gəncə, Gəncə–Daşkəsən şosesi, 1-ci km",
    phone: "+994 55 988 30 30",
    workingHours: "24 saat açıqdır",
    services: ["Qaz (LPG)", "Market"],
    hasCarWash: false,
    images: [
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/6onm1332_IMG_2399.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/hfc3ydff_IMG_2400.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/07fr3uny_IMG_2401.jpeg"
    ]
  },
  {
    id: 5,
    name: "LUKOIL EKTO - Balçılı",
    address: "Göygöl r., Balçılı k., M2 Bakı–Qazax şosesi, 376-cı km",
    phone: "+994 55 988 30 30",
    workingHours: "24 saat açıqdır",
    services: ["Market", "Kafe", "Motel", "Namaz otağı", "Avtoyuma", "Texniki qulluq"],
    hasCarWash: true,
    images: [
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/7vckb4g0_IMG_2402.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/0m3le5e7_IMG_2403.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/uthuht2k_IMG_2404.jpeg"
    ]
  },
  {
    id: 6,
    name: "LUKOIL EKTO - Qızılqaya",
    address: "Göygöl r., Qızılqaya qəsəbəsi",
    phone: "+994 55 988 30 30",
    workingHours: "24 saat açıqdır",
    services: ["Market", "Kafe", "Avtoyuma"],
    hasCarWash: true,
    images: [
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/n9vdum5p_IMG_2423.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/tkfu4mcq_IMG_2424.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/vhpvfaxd_IMG_2411.jpeg"
    ]
  },
  {
    id: 7,
    name: "LUKOIL EKTO - Bakı-Salyan şosesi",
    address: "Bakı, Bakı–Salyan şosesi, 56-cı km",
    phone: "+994 55 988 30 30",
    workingHours: "24 saat açıqdır",
    services: ["Market", "Kafe", "Namaz otağı", "Texniki qulluq"],
    hasCarWash: false,
    images: [
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/53w48uqa_IMG_2419.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/jw29i3p2_IMG_2417.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/7pl8x15e_IMG_2418.jpeg"
    ]
  },
  {
    id: 8,
    name: "LUKOIL EKTO - Əliyaqublu",
    address: "Şəmkir r., Əliyaqublu k.",
    phone: "+994 55 988 30 30",
    workingHours: "24 saat açıqdır",
    services: ["Market", "Kafe", "Namaz otağı", "Avtoyuma"],
    hasCarWash: true,
    images: [
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/3n17dib1_IMG_2392.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/rv8ckwbk_IMG_2390.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/d18n34ai_IMG_2391.jpeg"
    ]
  },
  {
    id: 9,
    name: "LUKOIL EKTO - Slavyanka",
    address: "Gədəbəy r., Slavyanka k.",
    phone: "+994 55 988 30 30",
    workingHours: "24 saat açıqdır",
    services: ["Market"],
    hasCarWash: false,
    images: [
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/9rlf47ma_IMG_2425.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/qnsmxbwp_IMG_2426.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/4z9ub6y9_IMG_2410.jpeg"
    ]
  },
  {
    id: 10,
    name: "LUKOIL EKTO - Şıxlı",
    address: "Qazax r., 2-ci Şıxlı k.",
    phone: "+994 55 988 30 30",
    workingHours: "24 saat açıqdır",
    services: ["Market", "Kafe", "Motel", "Hamam (Banyo)", "Namaz otağı", "Texniki qulluq", "Azercell"],
    hasCarWash: false,
    images: [
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/orjat52w_IMG_2422.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/zna4odcd_IMG_2420.jpeg",
      "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/nu65d4qe_IMG_2421.jpeg"
    ]
  }
];

export const reviews = [
  {
    id: 1,
    name: "Elçin Məmmədov",
    rating: 5,
    comment: "Çox keyfiyyətli yanacaq və peşəkar xidmət. Hər dəfə burada yanacaq doldururam. Tövsiyə edirəm!",
    date: "2025-01-15"
  },
  {
    id: 2,
    name: "Leyla Həsənova",
    rating: 5,
    comment: "Avtomoyka xidməti əladır. Maşınım təmiz və parlaq oldu. Minnətdaram!",
    date: "2025-01-10"
  },
  {
    id: 3,
    name: "Rəşad Quliyev",
    rating: 5,
    comment: "Əla stansiya! Personal mehriban və peşəkardır. Həm yanacaq keyfiyyətli, həm də qiymətlər ədalətlidir.",
    date: "2025-01-08"
  },
  {
    id: 4,
    name: "Səbinə Əliyeva",
    rating: 5,
    comment: "LUKOIL EKTO-ya tam etibar edirəm. Yanacaq keyfiyyətlidir və xidmət sürətlidir.",
    date: "2025-01-05"
  },
  {
    id: 5,
    name: "Kamran Əhmədov",
    rating: 5,
    comment: "24 saat açıq olması çox rahatdır. Gecə də gündüz də yanacaq doldura bilirəm. Əla xidmət!",
    date: "2024-12-28"
  },
  {
    id: 6,
    name: "Nigar İbrahimova",
    rating: 5,
    comment: "Mağazada hər şey var, qiymətlər ədalətli. Xidmət və keyfiyyət əladır!",
    date: "2024-12-20"
  }
];

export const services = [
  {
    id: 1,
    title: "Keyfiyyətli Yanacaq",
    description: "AI-92, AI-95 və Dizel yanacaq növləri. Beynəlxalq standartlara uyğun yüksək keyfiyyət və təmiz yanma. Avtomobilinizin mühərrikini qoruyur.",
    icon: "Fuel",
    image: "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/d0jv4za8_IMG_2484.jpeg"
  },
  {
    id: 2,
    title: "Market",
    description: "Yanacaqdoldurma stansiyalarımızda geniş məhsul çeşidi olan marketlər mövcuddur. İçkilər, qəlyanaltılar, ərzaq məhsulları və digər zəruri mallar.",
    icon: "Store",
    image: "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/bi33he8o_IMG_2486.jpeg"
  },
  {
    id: 3,
    title: "Avtoyuma",
    description: "Müasir avtoyuma texnologiyası ilə avtomobilinizi təmiz və parlaq saxlayın. Peşəkar avadanlıq və keyfiyyətli kimyəvi məhsullarla xidmət.",
    icon: "Droplets",
    image: "https://images.pexels.com/photos/6873191/pexels-photo-6873191.jpeg"
  },
  {
    id: 4,
    title: "Texniki qulluq",
    description: "Peşəkar avtomobil texniki xidməti. Mühərrik yoxlanışı, təmir işləri və texniki məsləhət. Təcrübəli mütəxəssislər və müasir avadanlıq.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1771340012378-3c86cb649193"
  },
  {
    id: 5,
    title: "Xüsusi Xidmət",
    description: "İdarə və təşkilatlar üçün yanacağın satışı və çatdırılması.",
    icon: "Truck",
    image: "https://customer-assets.emergentagent.com/job_ganja-fuel-stations/artifacts/ni8ps320_IMG_2483.jpeg"
  }
];

export const companyInfo = {
  name: "LUKOIL EKTO",
  fullName: "LUKOIL EKTO - Gəncə Yanacaqdoldurma Stansiyaları",
  description: "LUKOIL EKTO - Azərbaycanın müxtəlif regionlarında fəaliyyət göstərən beynəlxalq LUKOIL brendinin rəsmi yanacaqdoldurma stansiyaları. Biz müştərilərimizə yüksək keyfiyyətli yanacaq və peşəkar xidmət təqdim edirik.",
  phone: "+994 55 988 30 30",
  email: "ekto.lukoil@gmail.com",
  address: "Azərbaycan",
  established: "2010",
  stationCount: 10,
  values: [
    {
      title: "Keyfiyyət",
      description: "Beynəlxalq standartlara uyğun yüksək keyfiyyətli məhsullar"
    },
    {
      title: "Etibarlılıq",
      description: "Daimi və stabil xidmət göstərilməsi"
    },
    {
      title: "İnnovasiya",
      description: "Müasir texnologiyalar və inkişaf"
    },
    {
      title: "Müştəri məmnuniyyəti",
      description: "Hər bir müştəriyə fərdi yanaşma və diqqət"
    }
  ]
};
